import React, { useState, useEffect } from "react";
import { useAuth } from "../../../Context/AuthContext";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  IconButton,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClientNavtabs from "./ClientNavtabs";
const AddBusinessNo = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const leadId = location.state?.leadId;
  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("userId");
  // const token = sessionStorage.getItem("token");
  const apiUrl = process.env.REACT_APP_API_REST_URL;
  console.log(apiUrl, "apiUrl");
  const [currentUser, setCurrentUser] = useState({ name: "", ian: "" });
  const [rmOptions, setRmOptions] = useState([]);
  const [managerIdNameMap, setManagerIdNameMap] = useState({});
  const [leadData, setLeadData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [department, setDepartment] = useState([]);
  const [investmentType, setInvestmentType] = useState([]);
  const [product, setProduct] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedProductData, setSelectedProductData] = useState(null);
  const [investmentTypeOptions, setInvestmentTypeOptions] = useState([]);
  const [commission, setCommission] = useState(null);
  const [revenue, setRevenue] = useState(null);
  const [productDetailsList, setProductDetailsList] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onTouched" });

  // Handle menu navigation
  const handleMenuClick = (action) => {
    switch (action) {
      case "profile":
        navigate("/employeedashboard/clients/edit", {
          state: { leadId },
        });
        break;
      case "interactions":
        navigate("/employeedashboard/clients/interactions", {
          state: { leadId },
        });
        break;
      case "add-interaction":
        navigate("/employeedashboard/clients/add-interaction", {
          state: { leadId },
        });
        break;
      case "kyc":
        navigate("/employeedashboard/clients/kyc", {
          state: { leadId },
        });
        break;
      case "documents":
        // Navigate to documents
        break;
      case "add-business-numbers":
        break;
      case "business-numbers":
        navigate("/employeedashboard/clients/business-numbers", {
          state: { leadId },
        });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    const fetchLeadData = async () => {
      if (!leadId) {
        setIsLoading(false);
        setError("No lead ID provided");
        return;
      }

      try {
        setIsLoading(true);
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/referalEngine/getReferralById/${leadId}`
        );
        setLeadData(response.data);
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to load lead data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeadData();
  }, [leadId, apiUrl]);
  const getEarliestInteractionDate = (interactionDetails) => {
    if (!interactionDetails || interactionDetails.length === 0) {
      return null;
    }
    const sortedInteractions = [...interactionDetails].sort(
      (a, b) => new Date(a.meeting_at) - new Date(b.meeting_at)
    );

    return sortedInteractions[0].meeting_at;
  };
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/commonEngine/products`
        );
        if (response.data.status) {
          setProducts(response.data.response);
          console.log(response.data.response, "products");
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);
  // Populate form fields when component mounts
  useEffect(() => {
    if (leadData) {
      setValue("id", leadData.id);
      if (leadData?.firstname || leadData?.lastname || leadData?.phone) {
        setCurrentUser({
          name: `${leadData.firstname} ${leadData.lastname}`,
          ian: leadData.ian || null,
        });
      }
    }
  }, [leadData, setValue]);

  const cancelHandler = () => {
    navigate("/employeedashboard/clients/view", { state: { leadId } });
  };
  const getDepartmentData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/department`;
      const response = await axios.get(url, {});
      setDepartment(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getInvestmentTypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/investment_type`;
      const response = await axios.get(url, {});
      setInvestmentType(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  const getProductData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/product`;
      const response = await axios.get(url, {});
      setProduct(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getDepartmentData();
    getInvestmentTypeData();
    getProductData();
  }, []);
  const getInvestmentTypeId = (investmentTypeName) => {
    const found = investmentType.find(
      (type) => type.masterValueDesc === investmentTypeName
    );
    return found ? found.id : null;
  };

  const getDepartmentName = (departmentId) => {
    const found = department.find((dept) => dept.id === parseInt(departmentId));
    return found ? found.masterValueDesc : "";
  };
  const getProductName = (productId) => {
    let found = products.find((prod) => prod.id === parseInt(productId));
    if (found) return found.products;
    found = product.find((prod) => prod.id === parseInt(productId));
    return found ? found.masterValueDesc : "";
  };
  const handleDepartmentChange = (value) => {
    setSelectedDepartment(value);
    const filtered = products.filter((p) => {
      return String(p.departmentId) === String(value);
    });
    setFilteredProducts(filtered);
  };

  const handleProductChange = (productId) => {
    setSelectedProductId(productId);
    const selected = filteredProducts.find((p) => p.id === productId);
    setSelectedProductData(selected);
    const types = selected?.investmentType || [];
    setInvestmentTypeOptions(types);
    setCommission(selected?.comission);
  };
  const calculateRevenue = (amount) => {
    if (
      selectedProductData &&
      selectedProductData.comission &&
      selectedProductData.comission.includes("%")
    ) {
      const commissionRate = parseFloat(
        selectedProductData.comission.replace("%", "")
      );
      const total = (amount * commissionRate) / 100;
      setRevenue(total.toFixed(2));
    } else {
      setRevenue(null);
    }
  };
  const handleSave = (data) => {
    let selectedProduct = products.find(
      (p) => p.id === parseInt(data["Products / Business units"])
    );
    if (!selectedProduct) {
      selectedProduct = product.find(
        (p) => p.id === parseInt(data["Products / Business units"])
      );
    }

    if (!selectedProduct) {
      toast.error("Selected product not found");
      return;
    }
    const investmentTypeId = data["Investment Type"]
      ? getInvestmentTypeId(data["Investment Type"])
      : null;

    const newEntry = {
      transactionDate: data.transactionDate || null,
      department: parseInt(selectedDepartment),
      products: selectedProduct.productId || selectedProduct.id,
      investmentType: investmentTypeId,
      investmentAmount: data.investmentAmount
        ? parseFloat(data.investmentAmount)
        : null,
      noOfYears: data.noOfYears ? parseInt(data.noOfYears) : null,
      noOfMonths: data.noOfMonths ? parseInt(data.noOfMonths) : null,

      departmentName: getDepartmentName(selectedDepartment),
      productName: getProductName(data["Products / Business units"]),
      investmentTypeName: data["Investment Type"] || null,
      commission: commission,
      revenue: revenue,
    };

    setProductDetailsList([newEntry, ...productDetailsList]);
    reset();
    setSelectedDepartment("");
    setFilteredProducts([]);
    setSelectedProductData(null);
    setCommission(null);
    setRevenue(null);
    setInvestmentTypeOptions([]);
  };

  const handleRemove = (index) => {
    const updatedList = productDetailsList.filter((_, i) => i !== index);
    setProductDetailsList(updatedList);
  };
  const handleFinalSubmit = async (data) => {
    const headers = {
      "x-access-token": token,
    };
    const payloadEntries = productDetailsList.map((entry) => ({
      department: entry.department,
      products: entry.products,
      investmentType: entry.investmentType,
      investmentAmount: entry.investmentAmount,
      noOfYears: entry.noOfYears,
      noOfMonths: entry.noOfMonths,
      transactionDate: entry.transactionDate,
    }));
    const payload = {
      clientId: leadId,
      productDetails: payloadEntries,
    };
    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/referalEngine/productDetails`,
        payload,
        { headers }
      );

      if (
        response?.data?.statusMessage === "Success" &&
        response?.data?.response?.status === true
      ) {
        toast.success("Products added successfully");
        setTimeout(() => {
          navigate("/employeedashboard/clients/business-numbers", {
            state: { leadId },
          });
        }, 1000);
      } else {
        toast.error("Update failed");
      }
    } catch (error) {
      toast.error(
        "Update failed: " + (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <Box sx={styles.main_container}>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        toastStyle={{ textAlign: "left" }}
        theme="colored"
      />

      <Paper sx={styles.dashboard_paper}>
        <ClientNavtabs
          handleMenuClick={handleMenuClick}
          options={[
            {
              label: "Edit Profile",
              onClick: () => handleMenuClick("profile"),
            },
            {
              label: "View Interactions",
              onClick: () => handleMenuClick("interactions"),
            },
            {
              label: "Add Interaction",
              onClick: () => handleMenuClick("add-interaction"),
            },
            { label: "View KYC", onClick: () => handleMenuClick("kyc") },
            {
              label: "Upload Documents",
              onClick: () => handleMenuClick("documents"),
              disabled: true,
            },
            {
              label: "Add Business Numbers",
              onClick: () => handleMenuClick("add-business-numbers"),
            },
            {
              label: "View Business Numbers",
              onClick: () => handleMenuClick("business-numbers"),
            },
          ]}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "25%",
            marginLeft: "auto",
          }}
        >
          <Button sx={styles.btn} variant="contained" onClick={cancelHandler}>
            Back
          </Button>
        </Box>
      </Paper>

      <Paper
        elevation={3}
        sx={{
          margin: "10px 20px 20px 20px",
          height: "590px",
          borderRadius: "12px",
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          sx={{ marginBottom: "1rem", textAlign: "center", marginTop: "1rem" }}
        >
          Add Business Numbers:{" "}
          <span style={{ fontWeight: "bold" }}>{currentUser.name}</span>
          <span style={{ fontSize: "12px", marginLeft: "5px" }}>
            {currentUser.ian && `(${currentUser.ian})`}
          </span>
        </Typography>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100% - 80px)",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <form onSubmit={handleSubmit(handleSave)}>
            <Grid container spacing={2} my={1}>
              <Grid item xs={12} sm={4}>
                {/* <FormControl error={!!errors.transactionDate}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    label="Transaction Date"
                    type="date"
                    variant="outlined"
                    error={!!errors.transactionDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...register("transactionDate", {
                      required: "Transaction date is required",
                    })}
                    InputProps={{
                      inputProps: {
                        placeholder: "Select Date",
                        max: new Date().toISOString().split("T")[0],
                      },
                    }}
                  />
                  {errors.transactionDate && (
                    <FormHelperText>
                      {errors.transactionDate?.message}
                    </FormHelperText>
                  )}
                </FormControl> */}
                <FormControl error={!!errors.transactionDate}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    label="Transaction Date"
                    type="date"
                    variant="outlined"
                    error={!!errors.transactionDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...register("transactionDate", {
                      required: "Transaction date is required",
                      validate: (value) => {
                        // Check if date is in the past
                        const selectedDate = new Date(value);
                        const today = new Date();
                        today.setHours(23, 59, 59, 999);

                        if (selectedDate > today) {
                          return "Transaction date cannot be in the future";
                        }
                        if (leadData && leadData.interactionDetails) {
                          const earliestInteractionDate =
                            getEarliestInteractionDate(
                              leadData.interactionDetails
                            );

                          if (earliestInteractionDate) {
                            const interactionDate = new Date(
                              earliestInteractionDate
                            );
                            interactionDate.setHours(0, 0, 0, 0);
                            selectedDate.setHours(0, 0, 0, 0);

                            if (selectedDate < interactionDate) {
                              const formattedInteractionDate =
                                interactionDate.toLocaleDateString();
                              return `Transaction date cannot be before the first interaction date (${formattedInteractionDate})`;
                            }
                          }
                        }

                        return true;
                      },
                    })}
                    InputProps={{
                      inputProps: {
                        placeholder: "Select Date",
                        max: new Date().toISOString().split("T")[0],
                      },
                    }}
                  />
                  {errors.transactionDate && (
                    <FormHelperText sx={styles.textfield}>
                      {errors.transactionDate.message}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl
                  fullWidth
                  size="small"
                  sx={styles.textfield}
                  error={!!errors["Department / Vertical"]}
                >
                  <InputLabel id="department-label" sx={{ fontSize: "13px" }}>
                    Department / Vertical
                  </InputLabel>
                  <Controller
                    name="Department / Vertical"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Department / Vertical is required" }}
                    render={({ field }) => (
                      <Select
                        sx={{
                          "& .MuiSelect-select": {
                            textAlign: "left",
                          },
                        }}
                        labelId="department-label"
                        label="Department / Vertical"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e);
                          handleDepartmentChange(e.target.value);
                        }}
                      >
                        {department.map((dept) => (
                          <MenuItem
                            key={dept.id}
                            value={dept.id}
                            sx={styles.menuItem}
                          >
                            {dept.masterValueDesc}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  {errors["Department / Vertical"] && (
                    <FormHelperText>
                      {errors["Department / Vertical"]?.message}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl
                  fullWidth
                  size="small"
                  sx={styles.textfield}
                  error={!!errors["Products / Business units"]}
                >
                  <InputLabel id="products-label" sx={{ fontSize: "13px" }}>
                    Products / Business units
                  </InputLabel>
                  <Controller
                    name="Products / Business units"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Product / Business unit is required" }}
                    render={({ field }) => (
                      <Select
                        sx={{
                          "& .MuiSelect-select": {
                            textAlign: "left",
                          },
                        }}
                        labelId="products-label"
                        label="Products / Business units"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e);
                          handleProductChange(e.target.value);
                        }}
                      >
                        {filteredProducts.map((product) => (
                          <MenuItem
                            key={product.id}
                            value={product.id}
                            sx={styles.menuItem}
                          >
                            {product.products}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  {errors["Products / Business units"] && (
                    <FormHelperText>
                      {errors["Products / Business units"]?.message}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {investmentTypeOptions.length > 0 && (
                <Grid item xs={12} sm={4}>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={styles.textfield}
                    error={!!errors["Investment Type"]}
                  >
                    <InputLabel
                      id="investmentType-label"
                      sx={{ fontSize: "13px" }}
                    >
                      Investment Type
                    </InputLabel>
                    <Controller
                      name="Investment Type"
                      control={control}
                      defaultValue={
                        investmentTypeOptions.length === 1
                          ? investmentTypeOptions[0]
                          : ""
                      }
                      rules={{ required: "Investment type is required" }}
                      render={({ field }) => (
                        <Select
                          sx={{
                            "& .MuiSelect-select": {
                              textAlign: "left",
                            },
                          }}
                          labelId="investmentType-label"
                          label="Investment Type"
                          {...field}
                          value={field.value || ""}
                        >
                          {investmentTypeOptions.map((type, idx) => (
                            <MenuItem
                              key={idx}
                              value={type}
                              sx={styles.menuItem}
                            >
                              {type}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                    {errors["Investment Type"] && (
                      <FormHelperText>
                        {errors["Investment Type"]?.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              )}

              {selectedProductData?.noOfYears === "Yes" && (
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    label="No of Years"
                    variant="outlined"
                    type="number"
                    {...register("noOfYears", {
                      required: "No of Years is required",
                      valueAsNumber: true,
                      min: {
                        value: 0,
                        message: "Number of years must be 0 - 20",
                      },
                      max: {
                        value: 20,
                        message: "Number of years must be 0 - 20",
                      },
                    })}
                    error={!!errors.noOfYears}
                    helperText={errors.noOfYears?.message}
                    inputProps={{
                      min: 0,
                      max: 20,
                    }}
                  />
                </Grid>
              )}

              {selectedProductData?.noOfMonths === "Yes" && (
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    label="No of Months"
                    variant="outlined"
                    type="number"
                    {...register("noOfMonths", {
                      required: "No of Months is required",
                      valueAsNumber: true,
                      min: {
                        value: 0,
                        message: "Number of months must be 0 - 12",
                      },
                      max: {
                        value: 20,
                        message: "Number of months must be 0 -12",
                      },
                    })}
                    error={!!errors.noOfMonths}
                    helperText={errors.noOfMonths?.message}
                    inputProps={{
                      min: 0,
                      max: 12,
                    }}
                  />
                </Grid>
              )}

              {selectedProductData?.investmentAmount === "Yes" && (
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="small"
                    sx={styles.textfield}
                    label="Investment / Premium / Transaction Amount"
                    variant="outlined"
                    type="number"
                    {...register("investmentAmount", {
                      required:
                        "Investment / Premium / Transaction Amount is required",
                      valueAsNumber: true,
                      min: {
                        value: 1,
                        message: "Amount must be greater than 0",
                      },
                      onChange: (e) => calculateRevenue(e.target.value),
                    })}
                    error={!!errors.investmentAmount}
                    helperText={errors.investmentAmount?.message}
                  />
                </Grid>
              )}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "0.5rem",
              }}
            >
              {commission && (
                <Typography variant="body2">
                  Commission: {commission}
                </Typography>
              )}
              {revenue && commission && !commission.includes("Agreement") && (
                <Typography variant="body2" sx={{ marginLeft: "1rem" }}>
                  Total Revenue: ₹{revenue}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                marginTop: "1rem",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {productDetailsList.map((entry, index) => {
                const entryDetails = [];

                if (entry.transactionDate) {
                  const [year, month, day] = entry.transactionDate.split("-");
                  const formattedDate = `${day}-${month}-${year}`;
                  entryDetails.push({
                    label: "Date",
                    value: formattedDate,
                  });
                }
                if (entry.departmentName)
                  entryDetails.push({
                    label: "Department",
                    value: entry.departmentName,
                  });
                if (entry.productName)
                  entryDetails.push({
                    label: "Product",
                    value: entry.productName,
                  });
                if (entry.investmentTypeName)
                  entryDetails.push({
                    label: "Type",
                    value: entry.investmentTypeName,
                  });
                if (entry.investmentAmount)
                  entryDetails.push({
                    label: "Amount",
                    value: `₹${entry.investmentAmount}`,
                  });
                if (entry.noOfYears)
                  entryDetails.push({ label: "Years", value: entry.noOfYears });
                if (entry.noOfMonths)
                  entryDetails.push({
                    label: "Months",
                    value: entry.noOfMonths,
                  });
                if (entry.commission)
                  entryDetails.push({
                    label: "Commission",
                    value: entry.commission,
                  });
                if (entry.revenue)
                  entryDetails.push({
                    label: "Revenue",
                    value: `₹${entry.revenue}`,
                  });

                return (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      padding: "8px 12px",
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      marginBottom: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <Typography variant="body2" sx={{ flex: 1 }}>
                      {entryDetails.map((detail, i) => (
                        <span key={i}>
                          {detail.label}:{" "}
                          <Box component="span" fontWeight="bold">
                            {detail.value}
                          </Box>
                          {i !== entryDetails.length - 1 && " | "}
                        </span>
                      ))}
                      <IconButton
                        onClick={() => handleRemove(index)}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </Typography>
                  </Box>
                );
              })}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Button
                onClick={cancelHandler}
                variant="outlined"
                sx={{
                  color: "Black",
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  padding: "5px 15px",
                  background: "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  marginRight: "10px",
                  textTransform: "none",
                  "&:hover": { background: "#002C51" },
                }}
              >
                Add
              </Button>
              <Button
                onClick={handleFinalSubmit}
                variant="outlined"
                disabled={productDetailsList.length === 0}
                sx={{
                  padding: "5px 15px",
                  background:
                    productDetailsList.length === 0 ? "#ccc" : "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  textTransform: "none",
                  "&:hover": {
                    background:
                      productDetailsList.length === 0 ? "#ccc" : "#002C51",
                  },
                  "&:disabled": {
                    color: "#666",
                    background: "#ccc",
                  },
                }}
              >
                Submit
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default AddBusinessNo;
const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btn: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "340px",
    "& .MuiInputBase-input": {
      fontSize: "13px",
    },
    "& .MuiInputLabel-root": {
      fontSize: "13px",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
      fontSize: "0.6em",
    },
    menuItem: {
      fontSize: "13px",
    },
  },
};
